// `service` , a non-food line item (staff hours, equipment rental, corkage).
// Keeps these out of the food/drink category taxonomy. doc 38 Part 1.

import { z } from 'zod';

import type { ItemKindDefinition } from './registry-types';
import type { ServiceProfile } from './types';

export const ServiceProfileSchema = z.object({
  unit_label: z.string().max(40).optional(),
});

export const serviceKind: ItemKindDefinition<ServiceProfile> = {
  id: 'service',
  label: 'Service',
  noun: 'service',
  description: 'A non-food charge such as staff, equipment, or corkage.',
  defaultPricingMode: 'flat',
  allowedPricingModes: ['flat', 'per_unit_weight'],
  schema: ServiceProfileSchema as unknown as z.ZodType<ServiceProfile>,
  defaultProfile: () => ({}),
};
